module.exports = __webpack_public_path__ + "img/ASOFOM.a207ede9.svg";